import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { PublishGpsEventRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { PublishGpsEventResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const publishGpsEvent = (request: PublishGpsEventRequest, options?: CashRequestOptions) =>
  post<PublishGpsEventRequest, PublishGpsEventResponse>('/2.0/cash/publish-gps-event', request, {
    ...options,
    rejectOnError: true,
  })
